import { render, staticRenderFns } from "./SkillEffect.vue?vue&type=template&id=10655a32&scoped=true&"
import script from "./SkillEffect.vue?vue&type=script&lang=ts&"
export * from "./SkillEffect.vue?vue&type=script&lang=ts&"
import style0 from "./SkillEffect.vue?vue&type=style&index=0&id=10655a32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10655a32",
  null
  
)

export default component.exports